export default {
  objectToCss(obj) {
    return !obj ? "" : Object.entries(obj).map(([k, v]) => {
      k = k.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
      return `${k}:${v}`;
    }).join(";");
  },
};
